import { Button } from '@/shared/components';
import ExportIcon from '@/shared/assets/export-icon.svg?react';
import { useTranslation } from 'react-i18next';

type Props = {
  onClick: () => void;
};

export const HistoryExportButton = ({ onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="secondary"
      onClick={onClick}
      className="headline4 hover:bg-stroke hover:text-primary w-[4.2rem] md:w-auto h-[4.2rem] shadow-none gap-[0.8rem] bg-white rounded-full px-[1.6rem] py-[0.9rem]">
      <ExportIcon className="size-[2.4rem] text-foreground" />

      <span className="hidden md:block">{t('common.export')}</span>
    </Button>
  );
};
